<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px" @close="close">
    <!-- 所属用户 -->
    <el-form ref="form" :model="form" label-width="76px" @submit.native.prevent>
      <el-form-item label="用户ID">
        <el-input ref="" v-model.trim="form.user_code" autocomplete="off" disabled
          @keyup.enter.native="handleQuery"></el-input>
      </el-form-item>
      <!-- 包裹单号 -->
      <el-form-item label="订单号">
        <el-input ref="" v-model.trim="form.code" autocomplete="off" disabled
          @keyup.enter.native="handleQuery"></el-input>
      </el-form-item>
      <!-- 快捷回复 -->
      <el-form-item label="快捷回复" prop="shipping_type_name">
        <el-select v-model="form.refuse_remark" placeholder="请选择" style="width: 100%;">
          <el-option v-for="items in quickReplyList" :key="items.value" :label="items.label"
            :value="items.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="驳回理由">
        <el-input v-model.trim="form.refuse_remark" autocomplete="off" type="textarea" :rows="2" clearable
          @keyup.enter.native="handleQuery"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="bohui()">确认驳回</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Order_codePrintCheck, orderOutbound, buyRefuse } from '@/api/xgcApi'
export default {
  name: 'Out',
  components: {},
  data() {
    return {
      title: '订单驳回',
      gridData: [],
      visible: false,
      form: {
        user_code: '',
        code: '',
        id: '',
        refuse_remark: '',
        type: 1,
      },
      dialogFormVisible: false,
      options: [
        {
          value: 1,
          label: '全部出库',
        },
        {
          value: 2,
          label: '部分出库',
        },
      ],
      quickReplyList: [
        { value: 1, label: '您填写的链接无法打开，建议先在浏览器中测试一下，确认有效后再重新提交' },
        { value: 2, label: '您选择的尺码型号颜色没有货' },
      ],
    }
  },
  methods: {
    // 初始化请求数据
    async showEdit(row) {
      this.dialogFormVisible = true
      this.form.code = row.code
      this.form.id = row.id
      this.form.user_code = row.user_code
    },
    // 确认驳回
    bohui() {
      buyRefuse(this.form).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '已驳回',
          })
          this.$emit('change', res.data)
          this.close()
        }
      })
    },
    // 关闭弹窗
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
  },
}
</script>
<style scoped lang="scss">
:deep .el-input--small .el-input__inner {}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
